import { Component, OnInit } from '@angular/core';
import { Automobilia, SaleStatus } from '../../models/automobilia.model';
import { AutomobiliaService } from '../../services/automobilia.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-automobilia-management',
  templateUrl: './automobilia-management.component.html'
})
export class AutomobiliaManagementComponent implements OnInit {

  public automobilia: Automobilia[] = [];
  automobiliaToEdit: Automobilia;
  imagesToDelete: number[];

  files: File[];
  fileUrls: string[];
  fileMessage: string;

  automobiliaSaleStatus = SaleStatus;
  selectedSaleStatus: SaleStatus;
  automobiliaToRemove: Automobilia;

  constructor(private automobiliaService: AutomobiliaService,
              public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
    this.automobiliaService.automobilia.subscribe(automobilia => this.automobilia = automobilia);
  }

  toggleFilter(saleStatus: SaleStatus) {
    this.selectedSaleStatus = (this.selectedSaleStatus !== saleStatus) ? saleStatus : null;
  }

  editAutomobilia(automobilia: Automobilia) {
    this.automobiliaToEdit = {...automobilia};
  }

  removeAutomobilia(automobilia: Automobilia) {
    this.automobiliaService.deleteAutomobilia(automobilia).then(result => {
      // console.log('result:', result);
      this.automobiliaToEdit = null;
    }, error => {
      console.log('error:', error);
      this.automobiliaToEdit = null;
    });
  }

  createNewAutomobilia() {
    this.automobiliaToEdit = new Automobilia(null, '', '', SaleStatus.NotForSale, []);
  }

  saveAutomobilia(automobilia: Automobilia) {
    if (this.imagesToDelete) {
      this.automobiliaService.deleteAutomobiliaImages(this.automobiliaToEdit.id, this.imagesToDelete).then(() => {
        this.imagesToDelete = null;
      });
    }

    this.automobiliaService.saveAutomobilia(automobilia).then((savedAutomobilia: Automobilia) => {
      if (savedAutomobilia) {
        if (this.files) {
          this.automobiliaService.saveAutomobiliaFiles(savedAutomobilia, this.files).then((resultSavedFiles) => {
            this.files = null;
            this.fileUrls = null;
            this.fileMessage = null;
          });
        }
        this.automobiliaToEdit = null;
      }
    }, error => {
      console.log('error:', error);
      this.automobiliaToEdit = null;
    });
  }

  setAutomobiliaSaleStatus(automobilia: Automobilia, saleStatus: SaleStatus) {
    automobilia.saleStatus = saleStatus;
    this.saveAutomobilia(automobilia);
  }

  cancel() {
    this.automobiliaToEdit = null;
    this.imagesToDelete = null;
    this.files = null;
    this.fileUrls = null;
  }

  onFileChanged(event) {
    const mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) === null) {
      this.fileMessage = 'Only images are supported.';
      return;
    }

    this.files = Array.from(event.target.files);
    this.files.forEach((file, index) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (readerEvent) => {
        if (!this.fileUrls) {
          this.fileUrls = [];
        }
        this.fileUrls.push(reader.result.toString());
      };
    });
  }

  removeTempFile(deleteFile, deleteIndex) {
    this.files = this.files.filter(file => file !== deleteFile);
    this.fileUrls = this.fileUrls.filter((fileUrl, index) => index !== deleteIndex);
  }

  removeExistingFile(deleteImage, deleteIndex) {
    this.automobiliaToEdit.images = this.automobiliaToEdit.images.filter(image => image !== deleteImage);
    if (!this.imagesToDelete) {
      this.imagesToDelete = [];
    }
    this.imagesToDelete.push(deleteImage.id);
  }

}
